import { styled } from 'styled-components';
import { Card, Tag } from 'antd';

export const RecordingCard = styled(Card)`
  && {
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    cursor: pointer;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .ant-card-body {
      padding: 12px;
    }
  }
`;

export const CardTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #1a1a1a;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: 12px;
  color: #666;
`;

export const InfoRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const InfoLabel = styled.span`
  color: #999;
`;

export const InfoValue = styled.span`
  color: #333;
  margin-left: auto;
`;

export const StatusTag = styled(Tag)`
  && {
    font-weight: 600;
    margin-left: auto;
    margin-right: 0;
  }
`;
